import { Select } from "@mantine/core";
import { buildMonthOptions } from "pages/admin/statements/utils";
import React, { useEffect } from "react";

interface IEomMonthPickerProps {
  value: string | null;
  disabled?: boolean;
  onChange: (value: string | null) => void;
}

const EomMonthPicker: React.FC<IEomMonthPickerProps> = ({
  value,
  disabled,
  onChange,
}) => {
  const currentYear = new Date().getFullYear();
  const monthOptions = buildMonthOptions(currentYear);
  // Default to current month’s last day
  const currentMonth = new Date().getMonth(); // 0–11
  const defaultValue = monthOptions[currentMonth].value;

  // If parent passes null, auto‑select current month
  useEffect(() => {
    if (value === null) {
      onChange(defaultValue);
    }
  }, [value, defaultValue, onChange]);

  return (
    <Select
      w={300}
      disabled={disabled}
      label="Select Month"
      placeholder="Choose month"
      data={monthOptions}
      value={value}
      onChange={onChange}
      searchable={false}
      clearable={false}
      comboboxProps={{ withinPortal: true }}
    />
  );
};

export default EomMonthPicker;
